import React from 'react'
import StyledH2Heading from '../../common/components/styledH2Heading/StyledH2Heading'
import StyledXsText from '../../common/components/styledXsText/StyledXsText'

const CharacteristicsCard = ({ data }) => {
    return (
        <div className='flex flex-col gap-2 text-center'>
            <div>
                <StyledXsText fontColor="text-gray">{data.tagline}</StyledXsText>
            </div>
            <div>
                <StyledH2Heading fontColor="text-gradient">{data.digits}</StyledH2Heading>
            </div>
            <div>
                <StyledXsText fontColor="text-gray">{data.content}</StyledXsText>
            </div>
        </div>
    )
}

export default CharacteristicsCard
